<template>
  <div class="elencomodelli">
    <b-container fluid>
      <b-row class="headerbox">
        <b-col>
          <h5>Lista Modelli</h5>
        </b-col>
      </b-row>
      <br>
      <b-row>
        <b-col md="5">
          <b-form-group label-cols-sm="2" label="Cerca">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Cerca" />
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''"><font-awesome-icon icon="times-circle" /></b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col>
          <b-button variant="success" style="float: right" to="/admin/modelli/aggiungi"><font-awesome-icon icon="plus-circle" /> Aggiungi Modello</b-button>
        </b-col>
      </b-row>
      <br>
      <b-row>
        <b-col>
          <b-table
            :striped="true"
            :hover="true"
            :responsive="true"
            :items="lista"
            :fields="campi"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            @filtered="onFiltered"
          >
            <template slot="action" slot-scope="row">
              <b-button size="sm" variant="danger" v-on:click="openModalDeleteModello(row.item)"><font-awesome-icon icon="trash-alt" /></b-button>
              <b-button size="sm" style="margin-left: 10px;" :to="'/admin/modelli/modifica/'+row.item.id"><font-awesome-icon icon="edit" /></b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            align="center"
          />
        </b-col>
      </b-row>
    </b-container>

    <b-modal v-model="modal.delete" title="Conferma richiesta di eliminazione!">
      <p>Sei sicuro di voler eliminare <strong>{{modalData.delete.descrizione}}</strong>?</p>
      <div slot="modal-footer">
        <b-button class="float-right" variant="danger" style="margin-left: 10px" v-on:click="deleteModello(modalData.delete.id)">Si</b-button>
        <b-button class="float-right" v-on:click="modal.delete = false">No</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'elencomodelli',
  data() {
    return {
      lista: [],
      campi: [
        {key: 'descrizione', label: 'Descrizione Modello', sortable: true},
        {key: 'action', label: '', sortable: false}
      ],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      filter: null,
      modal: {
        delete: false
      },
      modalData: {
        delete: {}
      }
    }
  },
  created: function(){
    this.getListaModelli()
  },
  methods: {
    getListaModelli(){
      Vue.http.post('admin/modello/list', {}, {credentials : true}).then(response => {
        if(response.body.success){
            this.lista = response.body.list
            this.totalRows = this.lista.length
        }else{
          this.lista = []
            /*Vue.notify({
                group: 'global',
                title: 'Errore',
                text: "Lista modelli non caricata correttamente.",
                type: 'error'
            })*/
        }
      }, response => {})
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    openModalDeleteModello(item){
      this.modalData.delete = item
      this.modal.delete = true
    },
    deleteModello(id){
      Vue.http.post('admin/modello/delete/'+id, {}, {credentials : true}).then(response => {
        if(response.body.success){
          this.getListaModelli()
          
          this.modal.delete = false
          this.modalData.delete = {}

          Vue.notify({
              group: 'global',
              title: 'Operazione eseguita!',
              text: "Modello eliminato correttamente.",
              type: 'success'
          })
        }else{
          Vue.notify({
              group: 'global',
              title: 'Errore',
              text: response.body.msg,
              type: 'error'
          })
        }
      }, response => {})
    }
  }
}
</script>


<style>
</style>